import { render } from "./Logistics.vue?vue&type=template&id=b991d2d4"
import script from "./Logistics.vue?vue&type=script&lang=js"
export * from "./Logistics.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__